import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { mapService } from 'tdc-web-backend/enums/enums';
import { useTranslation } from 'react-i18next';
import {
  mapProviderScope,
  mapTechLanguage,
  mapTechPlatform,
  mapTechTool,
} from '../../../../utils/enums';
import ControlledRadioInput from '../../../../components/custom-inputs/ControlledRadioInput';
import CustomInput from '../../../../components/custom-input/CustomInput';

const Seller = () => {
  const { t } = useTranslation();
  return (
    <>
      <Box sx={{ display: 'flex' }}>
        <CustomInput
          input={<CustomInput.Autocomplete />}
          sx={{ flex: 1, alignSelf: 'flex-start' }}
          label={t('tenders.requiredService')}
          placeholder={t('tenders.selectRequiredServices')}
          name="skills.services"
          choices={mapService}
          translation={{ ns: 'enum' }}
          multiple
          withChips
          fullWidth
          required
        />

        <Divider
          orientation="vertical"
          sx={{ borderColor: '#E5E8FF', margin: '0 24px' }}
          flexItem
        />

        <CustomInput
          input={<CustomInput.Autocomplete />}
          sx={{ flex: 1, alignSelf: 'flex-start' }}
          label={t('settings.companyProfile.techPlatforms')}
          placeholder={t('tenders.selectTechPlatforms')}
          name="skills.platforms"
          choices={mapTechPlatform}
          multiple
          withChips
          fullWidth
        />
      </Box>

      <Box sx={{ display: 'flex' }}>
        <CustomInput
          input={<CustomInput.Autocomplete />}
          sx={{ mt: 3, flex: 1, alignSelf: 'flex-start' }}
          label={t('settings.companyProfile.techTools')}
          placeholder={t('tenders.selectTechTools')}
          name="skills.tools"
          choices={mapTechTool}
          multiple
          withChips
          fullWidth
        />

        <Divider
          orientation="vertical"
          sx={{ borderColor: '#E5E8FF', margin: '0 24px' }}
          flexItem
        />

        <CustomInput
          input={<CustomInput.Autocomplete />}
          sx={{ mt: 3, flex: 1, alignSelf: 'flex-start' }}
          label={t('settings.companyProfile.programmingLanguages')}
          placeholder={t('tenders.selectProgrammingLanguages')}
          name="skills.languages"
          choices={mapTechLanguage}
          multiple
          withChips
          fullWidth
        />
      </Box>

      <Divider
        orientation="horizontal"
        sx={{ borderColor: '#E5E8FF', margin: '40px 0' }}
        flexItem
      />

      {/* TODO: create new CustomInput.RadioInput component */}
      <ControlledRadioInput
        name="skills.providerScope"
        label={t('tenders.selectPreferedSupplierLocation')}
        options={mapProviderScope}
        required
      />
    </>
  );
};

export default Seller;
